class CardController {
  constructor() {
    this.name = 'card';
  }
}

export default CardController;



// WEBPACK FOOTER //
// ./client/app/components/card/card.controller.js